import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SearchItemDto } from '../../../core/services/api.service';
import { UserResolverService } from '../../../core/services/user-resolver.service';
import { Router } from '@angular/router';
import { SearchComponent } from '../search.component';
import { Permissions } from '../../../shared/common/permissions';
import { IsInternalDirective } from '../../directives/isinternal.directive';

@Component({
    selector: 'sn-location-quick-view',
    templateUrl: './location-quick-view.component.html',
    styleUrls: ['./location-quick-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IsInternalDirective]
})
export class LocationQuickViewComponent implements OnInit {
  private _userResolverService = inject(UserResolverService);
  private _router = inject(Router);
  private _dialogRef = inject<MatDialogRef<SearchComponent>>(MatDialogRef);

  get searchItem(): SearchItemDto | undefined {
    return this.item;
  }
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set searchItem(value: SearchItemDto | undefined) {
      this.item = value;
      this.quickView = JSON.parse(value?.quickActionContent ?? "");
  }

  isASMUser: boolean = false;
  item: SearchItemDto | undefined;
  quickView: any;
  permissions = Permissions;

  ngOnInit(): void {
    this._userResolverService.userInfo.subscribe(x => this.isASMUser = x.IsASM);
  }

  editLocation() {
    this._router.routeReuseStrategy.shouldReuseRoute = () => false;
    this._router.navigate(['/locations', this.item?.referenceId]);
    this._dialogRef.close();
  }
}
